export const timeWithZero = (time: number) => {
    if (time < 10) {
        return `0${time}`;
    }
    return time;
};

export const timer = (seconds: number) => {
    const minutes = Math.floor(seconds / 60);
    const secondsWithoutMinutes = seconds - minutes * 60;

    return `${timeWithZero(minutes)}:${timeWithZero(secondsWithoutMinutes)}`;
};

export const defaultTimerValue = (timerKey: string, timerValue = 60) => {
    const now = Date.now();
    const lastTimeFromStorage = Number(localStorage.getItem(timerKey));
    const passedSeconds = Math.ceil((now - lastTimeFromStorage) / 1000);
    const remainSeconds = Math.max(timerValue - passedSeconds, 0);
    return remainSeconds;
};
